import { Layout } from "@/components/layout/Layout";
import { ImmersiveHero } from "@/components/home/ImmersiveHero";
import { TrustMarquee } from "@/components/home/TrustMarquee";
import { ValueProposition } from "@/components/home/ValueProposition";
import { GlassServices } from "@/components/home/GlassServices";
import { TransformationSection } from "@/components/home/TransformationSection";
import { SafetyCycle } from "@/components/home/SafetyCycle";
import { TestimonialsWithMarquee } from "@/components/home/TestimonialsWithMarquee";
import { FAQ } from "@/components/home/FAQ";
import { RiskCalculator } from "@/components/home/RiskCalculator";
import { FullScreenCTA } from "@/components/home/FullScreenCTA";
import { StickyCTABar } from "@/components/common/StickyCTABar";
import { Helmet } from "react-helmet-async";

const Index = () => {
  const schemaData = {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    "name": "אדם בטיחות",
    "alternateName": "Adam Safety",
    "description": "ייעוץ בטיחות מקצועי, הדרכות בטיחות וסקרי סיכונים לעסקים בישראל",
    "url": "https://adam-safety.com",
    "logo": "https://adam-safety.com/og-image.png",
    "image": "https://adam-safety.com/og-image.png",
    "telephone": "+972-50-123-4567",
    "email": "Support@Adam-Safety.com",
    "address": {
      "@type": "PostalAddress",
      "addressCountry": "IL",
      "addressRegion": "Israel"
    },
    "geo": {
      "@type": "GeoCoordinates",
      "addressCountry": "IL"
    },
    "areaServed": {
      "@type": "Country",
      "name": "Israel"
    },
    "priceRange": "$$",
    "openingHoursSpecification": {
      "@type": "OpeningHoursSpecification",
      "dayOfWeek": ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday"],
      "opens": "08:00",
      "closes": "18:00"
    },
    "sameAs": [
      "https://wa.me/972501234567"
    ],
    "hasOfferCatalog": {
      "@type": "OfferCatalog",
      "name": "שירותי בטיחות",
      "itemListElement": [
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "הדרכות בטיחות",
            "description": "הדרכות עבודה בגובה, בטיחות אש, חומרים מסוכנים ועוד"
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "סקרי סיכונים",
            "description": "סקרי סיכונים מקיפים לזיהוי וניתוח סכנות במקום העבודה"
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "ייעוץ בטיחות",
            "description": "ליווי מקצועי להטמעת תרבות בטיחות בארגון"
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "ממונה בטיחות חיצוני",
            "description": "שירותי ממונה בטיחות במיקור חוץ"
          }
        }
      ]
    }
  };

  return (
    <Layout>
      <Helmet>
        <script type="application/ld+json">
          {JSON.stringify(schemaData)}
        </script>
      </Helmet>
      <ImmersiveHero />
      <TrustMarquee />
      <ValueProposition />
      <GlassServices />
      <TransformationSection />
      <SafetyCycle />
      <TestimonialsWithMarquee />
      <RiskCalculator />
      <FAQ />
      <FullScreenCTA />
      <StickyCTABar />
    </Layout>
  );
};

export default Index;
